<template>
    <div class="app-container">

        <el-dialog :title="addModelTitle" :visible.sync="updateDialogVisible" width="30%">
            <div>公司名称</div>
            <div style="margin-top: 20px;">
                <el-input v-model="currentObj.name" placeholder="公司名称" class="filter-item" clearable />
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirmUpdate">确 定</el-button>
            </span>
        </el-dialog>

        <el-dialog title="" :visible.sync="downloadCodeDialogVisible" width="30%" :close-on-click-modal="false">
            <div v-loading="imgLoading">
                <div style="display: flex;align-items: center;justify-content: center;">
                    <el-image style="width: 200px;height: 200px;" :src="WXMiniCode"></el-image>
                </div>
                <div style="display: flex;align-items: center;justify-content: center;margin-top: 20px;">
                    <el-button type="primary" @click="downloadFile">下载二维码</el-button>
                </div>
            </div>
            
        </el-dialog>

        <el-dialog title="" :visible.sync="lowerListDialogVisible" width="70%" :close-on-click-modal="false" v-if="lowerListDialogVisible">
            <lower-list :currentObj="currentObj"></lower-list>
        </el-dialog>


        <div class="filter-container">
            <el-button type="primary" @click="handleCreate('新增渠道')">新增</el-button>
            <div>
                <div class="filter-item">
                    <el-input v-model="listQuery.name" placeholder="公司名称" class="filter-item" clearable />
                </div>
                <el-button type="primary" :loading="listLoading" icon="el-icon-search" @click="handleFilter">搜索</el-button>
            </div>
        </div>


        <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>

            <el-table-column label="ID" min-width="50" align="center">
                <template slot-scope="scope">
                    <template>{{ scope.row.id }}</template>
                </template>
            </el-table-column>

            <el-table-column align="center" label="公司名称" min-width="80">
                <template slot-scope="scope">
                    <span>{{ scope.row.name }}</span>
                </template>
            </el-table-column>

            <el-table-column align="center" label="发行日期" min-width="80">
                <template slot-scope="scope">
                    <span>{{ scope.row.created_at }}</span>
                </template>
            </el-table-column>


            <el-table-column label="操作" align="center" width="200" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button size="mini" type="warning" @click="handleUpdate(scope.row, '修改渠道')">修改</el-button>

                    <el-button size="mini" type="primary" @click="handleDownloadCode(scope.row)">下载二维码</el-button>

                    <el-button size="mini" type="primary" @click="lowerList(scope.row)"
                        style="margin-top: 10px;">下级列表</el-button>

                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
                :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                @current-change="handleCurrentChange" />
        </div>
    </div>
</template>

<script>
import request from "@/utils/request";
import LowerList from "./components/lower-list"
import { channel } from "@/api/operation";

export default {
    data() {
        return {
            list: [],
            total: 0,
            listLoading: false,
            listQuery: {
                page: 1,
                limit: 10,
                name: '',
            },
            updateDialogVisible: false,
            downloadCodeDialogVisible: false,
            lowerListDialogVisible: false,
            isAddFlag: true,
            currentObj: {},
            addModelTitle: '',
            url: '',
            WXMiniCode: '',
            imgLoading: false,
        }
    },
    components: {
        LowerList
    },
    created() {
        this.getList()
     },
    methods: {
        async getList() {
            this.listLoading = true;
            const { data } = await channel.list(this.listQuery);
            this.list = data.data
            this.total = data.total
            this.listLoading = false;
        },
        handleFilter() {
            this.listQuery.page = 1
            this.getList();
        },
        handleSizeChange(val) {
            this.listQuery.limit = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.page = val;
            this.getList();
        },
        handleUpdate(scope, title) {
            this.addModelTitle = title
            this.currentObj = {...scope}
            this.isAddFlag = false
            this.updateDialogVisible = true
        },
        handleCreate(title) {
            this.addModelTitle = title
            this.currentObj = {}
            this.isAddFlag = true
            this.updateDialogVisible = true
        },
        async confirmUpdate() {
            if (this.isAddFlag) {
                // 新增
                await channel.add({name:this.currentObj.name})
            } else {
                // 修改
                await channel.add({name:this.currentObj.name,id:this.currentObj.id })
            }
            await this.getList();
            this.updateDialogVisible = false
        },
        async handleDownloadCode(scope) {
            this.WXMiniCode = ''
            this.downloadCodeDialogVisible = true
            this.imgLoading = true
            const { data,code } = await channel.getWXMiniCode({id: scope.id })
            if(code == 0) {
                this.WXMiniCode = data
                this.imgLoading = false
            }
        },
        async lowerList(scope) {
            this.lowerListDialogVisible = true
            this.currentObj = {...scope}
            // const { data } = await channel.lowerList({id: scope.id })
        },
        downloadFile() {
            let fileUrl = this.WXMiniCode;
            let fileName = new Date().getTime();

            const xhr = new XMLHttpRequest();

            // Open a GET request to the file URL
            xhr.open('GET', fileUrl, true);

            // Set the response type to 'blob'
            xhr.responseType = 'blob';

            // When the request is complete
            xhr.onload = function () {
                // Convert the response to a Blob object
                const blob = new Blob([this.response], { type: 'image/jpeg' });

                // Create a temporary link element
                const link = document.createElement('a');

                // Set the href attribute to the Blob object URL
                link.href = URL.createObjectURL(blob);

                // Set the download attribute to force download with the desired file name
                link.setAttribute('download', fileName);

                // Append the link to the document body
                document.body.appendChild(link);

                // Click the link to trigger the download
                link.click();

                // Remove the link from the document body after download
                document.body.removeChild(link);
            };

            // Send the request
            xhr.send();
            this.downloadCodeDialogVisible = false;
            this.url = '';
        }
    },
}
</script>
<style lang="scss" scoped>
.filter-container {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .filter-item {
        text-align: center;
    }
}
</style>